(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-quantity]');
    if (!input) return;
    const minimum = Number(input.dataset.minimum || 1);
    const increment = Number(input.dataset.increment || 1);
    const quantity = Number(input.value);
    if (quantity > 0) input.value = String(Math.min(Number(input.max || Infinity), minimum + Math.max(0, Math.ceil((quantity - minimum) / increment)) * increment));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sleek-gallery')) {
    customElements.define('sleek-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return
        this.controller = new AbortController()
        const options = { signal: this.controller.signal }
        this.modal = this.querySelector('[data-gallery-modal]')
        this.items = [...this.querySelectorAll('[data-gallery-item-wrapper]')]
        this.batchSize = Math.max(1, Number(this.dataset.galleryBatchSize) || 12)
        this.selectedCategory = 'all'
        this.limit = this.dataset.galleryDesignMode === 'true' ? Infinity : this.batchSize
        const filters = this.querySelector('[data-gallery-filters]')
        if (filters) filters.hidden = this.items.length === 0
        this.updateVisibility()
        this.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return
          const filter = event.target.closest('[data-gallery-filter]')
          if (filter) {
            this.selectedCategory = filter.dataset.galleryFilter
            this.limit = this.dataset.galleryDesignMode === 'true' ? Infinity : this.batchSize
            this.querySelectorAll('[data-gallery-filter]').forEach((button) => {
              button.setAttribute('aria-pressed', String(button === filter))
            })
            this.updateVisibility()
          }
          if (event.target.closest('[data-gallery-load-more]')) {
            const firstNewItem = this.matchingItems[this.limit]
            this.limit += this.batchSize
            this.updateVisibility()
            firstNewItem?.querySelector('[data-gallery-item]')?.focus({ preventScroll: true })
          }
          const item = event.target.closest('[data-gallery-item]')
          if (item && item.dataset.galleryImage && this.modal?.showModal && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
            event.preventDefault()
            this.trigger = item
            const image = this.querySelector('[data-gallery-modal-image]')
            image.src = item.dataset.galleryImage
            image.alt = item.dataset.galleryCaption || ''
            image.width = Number(item.dataset.galleryWidth) || 1600
            image.height = Number(item.dataset.galleryHeight) || 1200
            this.querySelector('[data-gallery-modal-caption]').textContent = item.dataset.galleryCaption || ''
            if (!this.modal.open) this.modal.showModal()
          }
          if (event.target.closest('[data-gallery-close]')) this.modal.close()
          if (event.target === this.modal) {
            const bounds = this.modal.getBoundingClientRect()
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.modal.close()
          }
        }, options)
        this.modal?.addEventListener('close', () => {
          if (this.trigger?.isConnected) this.trigger.focus()
        }, options)
        this.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest?.('[data-gallery-item-wrapper]')
          if (!item) return
          this.selectedCategory = 'all'
          this.limit = Infinity
          this.querySelectorAll('[data-gallery-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.galleryFilter === 'all')))
          this.updateVisibility()
        }, options)
      }
      updateVisibility() {
        this.matchingItems = this.items.filter(item => this.selectedCategory === 'all' || this.selectedCategory === item.dataset.galleryCategory)
        const shownItems = new Set(this.matchingItems.slice(0, this.limit))
        this.items.forEach(item => { item.hidden = !shownItems.has(item) })
        const count = this.querySelector('[data-gallery-count]')
        if (count) count.textContent = count.dataset.galleryCountTemplate.replace('[shown]', String(shownItems.size)).replace('[total]', String(this.matchingItems.length))
        const controls = this.querySelector('[data-gallery-controls]')
        if (controls) controls.hidden = this.matchingItems.length === 0
        const loadMore = this.querySelector('[data-gallery-load-more]')
        if (loadMore) loadMore.hidden = shownItems.size >= this.matchingItems.length
        this.querySelector('[data-gallery-empty]').hidden = this.matchingItems.length > 0 || this.dataset.hideEmpty === 'true'
      }
      disconnectedCallback() {
        this.controller?.abort()
        this.controller = null
        if (this.modal?.open) this.modal.close()
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-portfolio"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sleek-project-gallery')) {
    customElements.define('sleek-project-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller || this.dataset.designMode === 'true') return
        this.controller = new AbortController()
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true, signal: this.controller.signal })
        } else this.initialize()
      }
      initialize() {
        if (!this.isConnected || this.records) return
        this.sources = [...(this.closest('main') || document).querySelectorAll('[data-gallery-source]')]
        this.records = this.sources.flatMap(source => [...source.querySelectorAll('[data-gallery-item-wrapper]')].filter(item => item.querySelector('[data-gallery-item]')).map(item => ({ item, grid: item.parentElement })))
        if (!this.records.length) return
        this.sources.forEach(source => { source.hidden = true })
        const categories = ['vinyl-wraps', 'aero-installs']
        const groups = categories.map(category => this.records.filter(({ item }) => item.dataset.galleryCategory === category).map(({ item }) => item))
        this.items = []
        for (let index = 0; index < Math.max(...groups.map(group => group.length)); index++) {
          groups.forEach(group => { if (group[index]) this.items.push(group[index]) })
        }
        this.items.push(...this.records.filter(({ item }) => !categories.includes(item.dataset.galleryCategory)).map(({ item }) => item))
        this.grid = this.querySelector('[data-portfolio-grid]')
        this.modal = this.querySelector('[data-portfolio-modal]')
        this.batchSize = Math.max(1, Number(this.dataset.batchSize) || 12)
        this.category = 'all'
        this.limit = this.batchSize
        this.querySelectorAll('[data-portfolio-filter]').forEach(button => {
          const category = button.dataset.portfolioFilter
          button.querySelector('[data-portfolio-category-count]').textContent = String(this.items.filter(item => category === 'all' || item.dataset.galleryCategory === category).length)
        })
        this.updateGrid()
        this.querySelector('[data-portfolio-collection]').hidden = false
        const options = { signal: this.controller.signal }
        this.addEventListener('click', event => {
          if (!(event.target instanceof Element)) return
          const filter = event.target.closest('[data-portfolio-filter]')
          if (filter) {
            this.category = filter.dataset.portfolioFilter
            this.limit = this.batchSize
            this.updateGrid()
          }
          if (event.target.closest('[data-portfolio-more]')) {
            const nextItem = this.matching[this.limit]
            this.limit += this.batchSize
            this.updateGrid()
            nextItem?.querySelector('[data-gallery-item]')?.focus({ preventScroll: true })
          }
          const item = event.target.closest('[data-gallery-item]')
          if (item && this.modal?.showModal && !event.ctrlKey && !event.metaKey && !event.altKey && !event.shiftKey) {
            event.preventDefault()
            this.trigger = item
            const image = this.querySelector('[data-portfolio-image]')
            image.src = item.dataset.galleryImage
            image.alt = item.dataset.galleryCaption || ''
            image.width = Number(item.dataset.galleryWidth) || 1600
            image.height = Number(item.dataset.galleryHeight) || 1200
            this.querySelector('[data-portfolio-caption]').textContent = item.dataset.galleryCaption || ''
            if (!this.modal.open) this.modal.showModal()
          }
          if (event.target.closest('[data-portfolio-close]')) this.modal.close()
          if (event.target === this.modal) {
            const rect = this.modal.getBoundingClientRect()
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.modal.close()
          }
        }, options)
        this.modal.addEventListener('close', () => { if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true }) }, options)
      }
      updateGrid() {
        this.matching = this.items.filter(item => this.category === 'all' || item.dataset.galleryCategory === this.category)
        this.grid.replaceChildren(...this.matching)
        this.matching.forEach((item, index) => { item.hidden = index >= this.limit })
        this.querySelectorAll('[data-portfolio-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.portfolioFilter === this.category)))
        const count = this.querySelector('[data-portfolio-count]')
        count.textContent = count.dataset.countTemplate.replace('[shown]', String(Math.min(this.limit, this.matching.length))).replace('[total]', String(this.matching.length))
        this.querySelector('[data-portfolio-more]').hidden = this.limit >= this.matching.length
        this.querySelector('[data-portfolio-empty]').hidden = this.matching.length > 0
      }
      disconnectedCallback() {
        if (this.modal?.open) this.modal.close()
        this.controller?.abort()
        this.records?.forEach(({ item, grid }) => { item.hidden = false; grid.append(item) })
        this.sources?.forEach(source => { source.hidden = false })
        this.controller = null
        this.records = null
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function initializeSleekHeaders(scope) {
    scope.querySelectorAll('[data-mobile-navigation]').forEach((menu) => {
      if (menu.dataset.initialized) return;
      menu.dataset.initialized = 'true';
      const trigger = menu.querySelector('summary');
      const close = () => { menu.open = false; trigger.focus(); };
      const closeButton = menu.querySelector('[data-close-menu]');
      closeButton.addEventListener('click', close);
      closeButton.hidden = false;
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { event.preventDefault(); close(); }
      });
      const desktop = window.matchMedia('(min-width: 1200px)');
      desktop.addEventListener('change', () => { if (desktop.matches) menu.open = false; });
      document.addEventListener('click', (event) => { if (!menu.contains(event.target)) menu.open = false; });
    });
  }
  initializeSleekHeaders(document);
  document.addEventListener('shopify:section:load', (event) => initializeSleekHeaders(event.target));

  } catch(e) { console.error(e); }
})();
})();
